import { render, staticRenderFns } from "./SummaryDifferentName.vue?vue&type=template&id=7b6d4606&scoped=true"
import script from "./SummaryDifferentName.vue?vue&type=script&lang=js"
export * from "./SummaryDifferentName.vue?vue&type=script&lang=js"
import style0 from "./SummaryDifferentName.vue?vue&type=style&index=0&id=7b6d4606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6d4606",
  null
  
)

export default component.exports